export type MapLatLng = {
  lat: number
  lng: number
}

export type MapType = "roadmap" | "satellite"

export type MapOptions = {
  center?: MapLatLng
  zoom?: number
  hasControls?: boolean
  mapType?: MapType
}

export enum MapGeocoderStatus {
  OK = "OK",
  ERROR = "ERROR",
  INVALID_ADDRESS = "INVALID_ADDRESS",
}
